import { alpha } from "@mui/material";
import { IconProps } from "./IconProps";
import theme from "themes/Theme";

const UsersIcon: React.FC<IconProps> = ({ width = 64, height = 64 }) => {
  return (
    <svg height={height} width={width} viewBox="0 0 24 24">
      <g transform="translate(0 -1028.4)">
        <g
          fill={alpha(theme.palette.primary.main, 0.4)}
          transform="matrix(.77981 0 0 .78862 2.9634 174.84)"
        >
          <path
            d="m17 4a5 5 0 1 1 -10 0 5 5 0 1 1 10 0z"
            transform="translate(6 1088.4)"
          />
          <path d="m18 1096.4c-1.277 0-2.494 0.2-3.594 0.7-2.885 1.3-4.9779 4-5.3435 7.3 0 1.1 0.8329 2 1.9375 2h14c1.105 0 1.938-0.9 1.938-2-0.366-3.3-2.459-6-5.344-7.3-1.1-0.5-2.317-0.7-3.594-0.7z" />
        </g>
        <g
          fill={alpha(theme.palette.primary.main, 0.6)}
          transform="matrix(.77981 0 0 .78862 -7.0366 174.84)"
        >
          <path
            d="m17 4a5 5 0 1 1 -10 0 5 5 0 1 1 10 0z"
            transform="translate(6 1088.4)"
          />
          <path d="m18 1096.4c-1.277 0-2.494 0.2-3.594 0.7-2.885 1.3-4.9779 4-5.3435 7.3 0 1.1 0.8329 2 1.9375 2h14c1.105 0 1.938-0.9 1.938-2-0.366-3.3-2.459-6-5.344-7.3-1.1-0.5-2.317-0.7-3.594-0.7z" />
        </g>
        <path
          d="m8.4062 1041.1c-2.8856 1.3-4.9781 4-5.3437 7.3 0 1.1 0.8329 2 1.9375 2h14c1.105 0 1.938-0.9 1.938-2-0.366-3.3-2.459-6-5.344-7.3-0.649 1.3-2.011 2.3-3.594 2.3s-2.9453-1-3.5938-2.3z"
          fill={alpha(theme.palette.primary.main, 1)}
        />
        <path
          d="m17 4a5 5 0 1 1 -10 0 5 5 0 1 1 10 0z"
          fill={alpha(theme.palette.primary.main, 1)}
          transform="translate(0 1031.4)"
        />
        <path
          d="m12 11c-1.277 0-2.4943 0.269-3.5938 0.75-2.8856 1.262-4.9781 3.997-5.3437 7.25 0 1.105 0.8329 2 1.9375 2h14c1.105 0 1.938-0.895 1.938-2-0.366-3.253-2.459-5.988-5.344-7.25-1.1-0.481-2.317-0.75-3.594-0.75z"
          fill={alpha(theme.palette.primary.main, 1)}
          transform="translate(0 1028.4)"
        />
      </g>
    </svg>
  );
};

export default UsersIcon;
